
import { i18nText } from '@/locales';

import {Component, Watch} from 'vue-property-decorator';
import PageTitle from '@/UI/components/common/PageTitle.vue';
import {ITableColumn} from '@/entity/table/table.types';
import {ServicesCategoryStore} from '@/store/modules/ServicesCategory';
import {TablesStore} from '@/store/modules/Tables';
import LoyaltySubscriptionTypeAddComponent
  from '@/UI/components/forms/loyalty/loyaltySubscription/loyaltySubscriptionType/LoyaltySubscriptionTypeAddComponent.vue';
import LoyaltySubscriptionTypeUpdateComponent
  from '@/UI/components/forms/loyalty/loyaltySubscription/loyaltySubscriptionType/LoyaltySubscriptionTypeUpdateComponent.vue';
import {LoyaltySubscriptionTypeStore} from '@/store/modules/Loyalty/Subscription/LoyaltySubscriptionType';
import BaseDataForm from '@/UI/components/Helpers/BaseForm/BaseDataForm.vue';
import {NewProxyDataForm} from '@/UI/components/Helpers/NewProxyDataForm';
import {mixins} from 'vue-class-component';
import {SubscriptionTypeMix} from '@/UI/mixins/Loaylty/SubscriptionTypeMix';
import {serviceswithQuillwortMix} from '@/UI/mixins/Store/serviceswithQuillwortMix';
import {Button, FormModel, List, Menu, Modal, Select, Table, Tabs, Checkbox} from 'ant-design-vue';
import {
  loyaltySubscriptionTypeForm,
  SubscribtionTypeServices,
  FormRules
} from '@/form/loyalty/loyaltySubscription/loyaltySubscriptionType';
import {ServiceCategoryMix} from '@/UI/mixins/Service/ServiceCategoryMix';
import {IServicesCategoryListItem} from '@/entity/servicesCategory/services.category.types';
import {getRouteFilter, setRouteFilter} from "@/entity/filters/extFilter";
import SortComponent from "@/UI/components/Helpers/components/SortComponent.vue"
import {TableColumns} from "@/UI/pages/loyalty/lib/table"
import {ResponseDataType} from "@/form/form.types";
import {getStudioId} from "@/UI/lib/state";
import {ProxyGetData} from "@/UI/components/Helpers/getData";
import {appPaginationStore} from "@/store/modules/appPagination";

@Component({
  components: {
    'a-button': Button,
    'a-menu-item': Menu.Item,
    'a-list-item': List.Item,
    'a-list-item-meta': List.Item.Meta,
    'a-select': Select,
    'a-select-option': Select.Option,
    'a-select-opt-group': Select.OptGroup,
    'a-table': Table,
    'a-tab': Tabs,
    'a-tab-pane': Tabs.TabPane,
    'a-modal': Modal,
    'a-form-model': FormModel,
    'a-form-model-item': FormModel.Item,
    'a-checkbox': Checkbox,
    BaseDataForm,
    PageTitle,
    LoyaltySubscriptionTypeAddComponent,
    LoyaltySubscriptionTypeUpdateComponent,
    SortComponent
  },
  methods: {
    setRouteFilter,
    getRouteFilter,
  },
})
export default class LoyaltySubscriptionType extends mixins(
    ProxyGetData,
    SubscriptionTypeMix,
    serviceswithQuillwortMix,
    ServiceCategoryMix,
    TableColumns
) {
  form = new loyaltySubscriptionTypeForm();
  rules = FormRules;
  saving = false
  showModalEdit = false
  storeEditMode = 0
  months: any = [
    {mo: '1'},
    {mo: '2'},
    {mo: '3'},
    {mo: '4'},
    {mo: '5'},
    {mo: '6'},
    {mo: '7'},
    {mo: '8'},
    {mo: '9'},
    {mo: '10'},
    {mo: '11'},
    {mo: '12'},
  ]

  // eslint-disable-next-line @typescript-eslint/explicit-module-boundary-types
  deleteCard(index: any) {
    this.form.services.splice(index, 1);
    this.calcSum();
  }

  async editCard(record: any): Promise<void> {
    this.form = new loyaltySubscriptionTypeForm();
    this.form.setFormData({...record, services: record.services.map((service: any) => ({id: service.id, category: service.category_id, all: false, quantity: service.pivot.quantity}))});
    this.storeEditMode = 1;
    this.modalTitle = i18nText('Редактирование типа абонемента');
    this.showModal = true;
  }

  public addService(): void {
    const service = new SubscribtionTypeServices();
    this.form.services.push(service);


  }

  modalTitle = i18nText("Создать тип абонемента");
  searchedColumn = '';
  showModal = false;
  dataServiceCategories: Array<IServicesCategoryListItem> = [];

  // eslint-disable-next-line @typescript-eslint/explicit-module-boundary-types
  addTypeSubscription() {
    this.form = new loyaltySubscriptionTypeForm();
    this.storeEditMode = 0;
    this.modalTitle = i18nText('Создать тип абонемента');
    this.showModal = true
  }

  // eslint-disable-next-line @typescript-eslint/explicit-module-boundary-types
  checkServiceAlreadyChosen(service: Record<any, any>) {
    let noneServicesPicked = (this.form.services && this.form.services.length == 0);
    let serviceAlreadyPicked = (this.form.services && this.form.services.filter(el => el.id === service.id).length !== 0);
    return noneServicesPicked || !serviceAlreadyPicked;
  }
  // eslint-disable-next-line @typescript-eslint/explicit-module-boundary-types
  handleServiceSelection(index: number, service: Record<any, any>) {
    this.form.services[index].id = service.id;
  }
  // eslint-disable-next-line @typescript-eslint/explicit-module-boundary-types
  calcSum() {
    let servicesPrices: Record<number, any> = {};

    if (this.servicesCategory) {
      for (let i = 0; i < this.servicesCategory.data.length; i++) {
        if (this.servicesCategory.data[i] && this.servicesCategory.data[i].services) {
          for (let j = 0; j < this.servicesCategory.data[i].services.length; j++) {
            if (this.servicesCategory.data[i].services[j]) {
              servicesPrices[this.servicesCategory.data[i].services[j].id] = this.servicesCategory.data[i].services[j].price_first;
            }
          }
        }
      }
    }

    if (this.form.services) {
      let total_price = 0;
      for (let i = 0; i < this.form.services.length; i++) {
        if (this.form.services[i]) {
           
          let id = this.form.services[i].id ?? 0;
          let quantity = this.form.services[i].quantity ?? 1;
          let price = servicesPrices[id] ?? 0
          total_price += price * quantity;
        }
      }
      this.form.price = total_price;
    }

  } 

  @Watch('$store.state.salon_id')
  @Watch('$route.params.Studio')
  async refreshCategories(): Promise<void> {
    this.showModal = false;
    await ServicesCategoryStore.fetchAll({filter: {salon_id: getStudioId(this)}, limit: -1});
    this.assignCategoriesSearch();
  }

  refreshPagination(): void {
    if (this.loyaltySubscriptionTypes) {
      this.AppPageParams.total = this.loyaltySubscriptionTypes.total;
    }
  }

  assignCategoriesSearch(): void {
    
    if (ServicesCategoryStore.serviceCategory) {
      let items = [];
      items = ServicesCategoryStore.serviceCategory.data;
      this.dataServiceCategories = [];
      items.forEach((item) => {
        this.dataServiceCategories.push(item);
      });
    }
  }

  onSubmit(): void {
    if (this.saving) return;
    (this.$refs.subscriptionTypeForm as FormModel).validate(async (valid) => {
      if (!valid) return;
      if (!this.form.services.length || this.form.services.some(service => !service.id || !Number.isInteger(Number(service.quantity)) || Number(service.quantity) < 1)) {
        this.$message.error(i18nText('Выберите услугу и количество для каждой позиции.'));
        return;
      }
      this.saving = true;
      try {
        this.form.salon_id = getStudioId(this);
        const response = this.storeEditMode === 0 ? await LoyaltySubscriptionTypeStore.create(this.form) : await LoyaltySubscriptionTypeStore.update(this.form);
        if (response.status) { this.$message.success(response.response); this.showModal = false; await this.getData(); }
        else this.$message.error(response.response);
      } catch (error) {
        this.$message.error(error.response?.data?.errors ? Object.values(error.response.data.errors).flat().join(' ') : error.response?.data?.message || error.message);
      } finally { this.saving = false; }
    });
  }

  async setFilter({by, sort}: { by: string; sort: any }): Promise<void>  {
      await this.sortedData(by, {dataIndex: sort.dataIndex})
  }

  handleCancel(): void {
    this.showModal = false;
  }

  get columns(): ITableColumn[] {
    return TablesStore.loyaltySubscriptionType
  }
  
  async created(): Promise<void> {
    console.log(">>>>>>>>>>> created SubscriptionsType")
      try {
        await ServicesCategoryStore.fetchAll({filter: {salon_id: getStudioId(this)}, limit: -1});
        this.assignCategoriesSearch();
      this.proxyFilter = {
          salon_id: getStudioId(this)
      };
      appPaginationStore.setCurrent(1)
      await this.sortedData('desc', {dataIndex: 'created_at'})
    } catch (e) {
      console.log(e)
    } finally {
      this.formReady = true
    }
  }
}
